import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';
import main_banner from '../../assets/images/main_banner.avif';
import overlayImage from '../../assets/images/iAbig.svg';
import { scrollToSection } from '../../utils/commonUtils';

export default function HeroSection() {
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat "
      style={{ backgroundImage: `url(${main_banner})` }}
    >
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-100"></div>

      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30 animate-overlayFadeIn"
        style={{ backgroundImage: `url(${overlayImage})`, clipPath: 'inset(100% 0 0 0)' }}
      ></div>
      <div className="container">
        <div className="relative z-10 text-center">
          <h1 className="text-4xl md:text-7xl font-bold text-white opacity-0 animate-textFadeIn">
            {t('Hero.title1')}
            <span className="mt-2 lg:mt-4 block text-center">
              {t('Hero.title2')}
              <div className="block md:hidden mt-2 md:mt-0" />
              {t('Hero.title3')}
            </span>
          </h1>

          <div className="my-10 md:my-14">
            <p className="text-p4 md:text-p1 text-white opacity-0 animate-textFadeInDelayed">
              {t('Hero.subtitle1')}
            </p>
            <p className="text-p4 md:text-p1 text-white opacity-0 animate-textFadeInDelayed">
              {t('Hero.subtitle2')}
              <div className="block md:hidden" />
              {t('Hero.subtitle3')}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center opacity-0 animate-arrowFadeIn">
          <button
            className="w-8 h-8 text-white cursor-pointer bg-transparent border-none p-0 animate-bounce"
            aria-label="Scroll to Product"
            onClick={() => scrollToSection('company-section1')}
          >
            <FaChevronDown size={32} />
          </button>
        </div>
      </div>
    </section>
  );
}
